import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Button, List, ListItem, ListItemText, Divider, Box, Paper } from '@mui/material';
import Lesson from '../componets/Lesson/Lesson';
import ProgressTracker from '../componets/ProgressTracker/ProgressTracker';
import CertificateGenerator from '../componets/CertificateGenerator/CertificateGenerator';

const mockCourseDetails = {
  1: {
    title: 'Mantenimiento Preventivo',
    description: 'Aprende las mejores prácticas de mantenimiento preventivo.',
    lessons: [
      { id: 1, title: 'Introducción al mantenimiento preventivo', content: '...' },
      { id: 2, title: 'Planificación de mantenimiento', content: '...' },
      { id: 3, title: 'Técnicas de inspección', content: '...' },
      { id: 4, title: 'Documentación y registros', content: '...' },
    ],
    minPassingScore: 70,
  },
};

const CourseDetails = () => {
  const { id } = useParams();
  const [course, setCourse] = useState(null);
  const [currentLesson, setCurrentLesson] = useState(null);
  const [completedLessons, setCompletedLessons] = useState(0);
  const [testScore, setTestScore] = useState(null);
  const [showCertificate, setShowCertificate] = useState(false);

  useEffect(() => {
    // Aquí se haría la llamada a la API para obtener los detalles del curso
    setCourse(mockCourseDetails[id]);
  }, [id]);

  const handleStartCourse = () => {
    setCurrentLesson(course.lessons[0]);
  };

  const handleCompleteLesson = () => {
    setCompletedLessons(completedLessons + 1);
    const nextLessonIndex = course.lessons.findIndex(lesson => lesson.id === currentLesson.id) + 1;
    if (nextLessonIndex < course.lessons.length) {
      setCurrentLesson(course.lessons[nextLessonIndex]);
    } else {
      setCurrentLesson(null);
      // Aquí se simularía la toma del test final
      const simulatedTestScore = Math.floor(Math.random() * 101);
      setTestScore(simulatedTestScore);
      if (simulatedTestScore >= course.minPassingScore) {
        setShowCertificate(true);
      }
    }
  };

  if (!course) {
    return <Typography>Cargando...</Typography>;
  }

  return (
    <Box sx={{ maxWidth: 800, margin: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>{course.title}</Typography>
      <Typography variant="body1" paragraph>{course.description}</Typography>
      
      <ProgressTracker 
        completedLessons={completedLessons} 
        totalLessons={course.lessons.length} 
        testScore={testScore}
      />

      {!currentLesson && !showCertificate && (
        <>
          <Typography variant="h5" gutterBottom>Lecciones del curso:</Typography>
          <List>
            {course.lessons.map((lesson) => (
              <React.Fragment key={lesson.id}>
                <ListItem>
                  <ListItemText primary={lesson.title} />
                </ListItem>
                <Divider />
              </React.Fragment>
            ))}
          </List>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleStartCourse} 
            sx={{ mt: 2 }}
          >
            {completedLessons > 0 ? 'Continuar Curso' : 'Comenzar Curso'}
          </Button>
        </>
      )}

      {currentLesson && (
        <Paper elevation={3} sx={{ p: 3, mt: 3 }}>
          <Lesson lesson={currentLesson} />
          <Button 
            variant="contained" 
            color="primary" 
            onClick={handleCompleteLesson}
            sx={{ mt: 2 }}
          >
            Completar Lección
          </Button>
        </Paper>
      )}

      {showCertificate && (
        <CertificateGenerator 
          userName="Nombre del Usuario"
          courseName={course.title}
          completionDate={new Date().toLocaleDateString()}
        />
      )}
    </Box>
  );
};

export default CourseDetails;